import { IAppState } from '../../redux';
import { getFirstOrSecondPhone } from '../../utils';

export function selectPhone(state: IAppState): string {
  if (state.offer.phones && state.offer.phones[0] !== null) {
    return getFirstOrSecondPhone(state.offer.phones) || '';
  }

  return '';
}
